module.exports = __webpack_public_path__ + "static/media/list.a8742963.svg";